import {Animate} from "../_snowpack/pkg/react-move.js";
import {easeExpOut} from "../_snowpack/pkg/d3-ease.js";
import React from "../_snowpack/pkg/react.js";
import "./IrradiationGauge.css";
export const IrradiationGauge = ({irradiation, mobile}) => {
  const min = 594;
  const max = 2200;
  return /* @__PURE__ */ React.createElement("div", {
    className: "map-picker-irradiation-gauge js"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "map-picker-irradiation-gauge-legend"
  }, mobile ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", null, "600"), /* @__PURE__ */ React.createElement("span", null, "1000"), /* @__PURE__ */ React.createElement("span", {
    style: {textAlign: "right"}
  }, "1400"), /* @__PURE__ */ React.createElement("span", {
    style: {textAlign: "right"}
  }, "1800"), /* @__PURE__ */ React.createElement("span", {
    style: {textAlign: "right"}
  }, "2200")) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", null, "600"), /* @__PURE__ */ React.createElement("span", null, "800"), /* @__PURE__ */ React.createElement("span", null, "1000"), /* @__PURE__ */ React.createElement("span", null, "1200"), /* @__PURE__ */ React.createElement("span", {
    style: {textAlign: "right"}
  }, "1400"), /* @__PURE__ */ React.createElement("span", {
    style: {textAlign: "right"}
  }, "1600"), /* @__PURE__ */ React.createElement("span", {
    style: {textAlign: "right"}
  }, "1800"), /* @__PURE__ */ React.createElement("span", {
    style: {textAlign: "right"}
  }, "2000"), /* @__PURE__ */ React.createElement("span", {
    style: {textAlign: "right"}
  }, "2200"))), /* @__PURE__ */ React.createElement(Animate, {
    show: true,
    start: {x: irradiation},
    update: () => ({
      x: [irradiation],
      timing: {duration: 750, ease: easeExpOut}
    })
  }, (state) => {
    const {x} = state;
    return /* @__PURE__ */ React.createElement("div", {
      className: "wrap",
      style: {height: "20px", "--min": min, "--max": max, "--val": x}
    }, /* @__PURE__ */ React.createElement("input", {
      style: {height: "20px"},
      type: "range",
      min: "600",
      max: "2200",
      onChange: () => {
      },
      value: x,
      className: "slider",
      list: "tickmarks",
      id: "myRange"
    }), /* @__PURE__ */ React.createElement("output", {
      htmlFor: "myRange"
    }, Math.round(x), " kWh/㎡"));
  }), /* @__PURE__ */ React.createElement("div", {
    style: {backgroundColor: "white", marginLeft: -1, marginRight: -1, height: "30px"}
  }, " "));
};
